import { createAction } from 'redux-actions';
export var fetchFreshDeviations = createAction("EDITOR.FETCH_FRESH_DEVIATIONS", function (_a) {
    var deviationIds = _a.deviationIds, setEntityData = _a.setEntityData;
    return ({ deviationIds: deviationIds, setEntityData: setEntityData });
});
//# sourceMappingURL=actionCreators.js.map